import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './ApiController/AuthContext'
import { CallProvider } from './components/CallContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './components/i18n';
import { LanguageProvider } from './components/LanguageContext';
import { DashboardProvider } from './components/Context/Dashboardcontext';
import { IncomingCallPopup } from './components/IncomingCall';
import GlobalCallManager from './components/Context/GlobalCallManager';

// Automatically disable all console outputs
console.log = () => {};
console.error = () => {};
console.warn = () => {};
console.debug = () => {};
console.info = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <DashboardProvider>
        <LanguageProvider>
          <AuthProvider>
            <CallProvider>
              {/* Ensure popup is inside CallProvider */}
              <IncomingCallPopup />
              <GlobalCallManager/>
              <App />
            </CallProvider>
          </AuthProvider>
        </LanguageProvider>
      </DashboardProvider>
    </I18nextProvider>
  </BrowserRouter>
);

reportWebVitals();